import { CleanlinessRankBy } from '../../../../app/types/cleanliness-score'

const CLEANLINESS_RANK_BY: { [key in CleanlinessRankBy]: key } = {
  technician: 'technician',
  van: 'van',
}

// Trailing window the rolling score covers.
const CLEANLINESS_WINDOW_DAYS = 30

// Proposed default bands (FRON-1601 decision 3). At or above `clean` is
// clean, at or above `watch` is watch, anything lower needs attention.
const CLEANLINESS_SCORE_BANDS = {
  clean: 85,
  watch: 70,
}

// The ai_audit_prompt row (auditType weekly-dvir) that overrides the built-in
// rubric. Must match CLEANLINESS_PROMPT_SECTION_KEY in
// app/eworkflows/audit/cleanliness/constants.ts; the frontend can't import
// runtime values from there.
const CLEANLINESS_PROMPT_SECTION_KEY = 'cleanliness_score'
const CLEANLINESS_PROMPT_SECTION_TITLE = 'Van Cleanliness Rubric'

export {
  CLEANLINESS_PROMPT_SECTION_KEY,
  CLEANLINESS_PROMPT_SECTION_TITLE,
  CLEANLINESS_RANK_BY,
  CLEANLINESS_WINDOW_DAYS,
  CLEANLINESS_SCORE_BANDS,
}
